<template>
  <footer class="footer">
    <div class="content has-text-centered">
      <p>
        <strong>Morales.bet</strong> by
        <a href="https://jgthms.com">Detox Inc.</a> The source code is licensed
        <a href="http://opensource.org/licenses/mit-license.php">MIT</a>. The
        website content is licensed
        <a href="http://creativecommons.org/licenses/by-nc-sa/4.0/"
          >CC BY NC SA 4.0</a
        >.
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  components: {},
  // props: {
  // },
  data() {
    return {}
  },
  created() {},
  methods: {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
